var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isPickup
    ? _c(
        "div",
        {
          staticClass: "shipping-notice checkout",
          staticStyle: { "margin-left": "-1.25em" }
        },
        [
          _vm.isPickupAndDeliveryNotGermany
            ? [
                _c("h4", { attrs: { className: "pt-1" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "KrauseSohn::Template.checkoutNoShippingForeignCountries"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "KrauseSohn::Template.checkoutNoShippingForeignCountriesDescription"
                      )
                    )
                  )
                ])
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("h4", [_vm._v("Wichtig!")]),
          _vm._v(" "),
          _c("p", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$translate("KrauseSohn::Template.pickupNotice")
              )
            }
          }),
          _vm._v(" "),
          _c("div", { attrs: { className: "form-check" } }, [
            _c(
              "label",
              {
                attrs: { htmlFor: "checkPickup", className: "form-check-label" }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$translate(
                        "KrauseSohn::Template.checkoutPickUpOptInText"
                      )
                    ) +
                    "\n    "
                )
              ]
            )
          ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }